import { ApplicationMenu as t } from "./applicationMenu.js";
class i {
  id;
  click;
  enabled;
  visible;
  htmlProps;
  icon;
  description;
  before;
  after;
}
class l extends i {
  type = "submenu";
  submenu;
  label;
  constructor({ submenu: s, label: n, ...u }) {
    super(), this.label = n, Array.isArray(s) ? this.submenu = t.buildFromTemplate(s) : this.submenu = new t(), Object.assign(this, u);
  }
}
const m = (e) => e.type === "submenu";
export {
  l as SubmenuMenuItem,
  m as isSubmenuMenuItem
};
